import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";
import {FrontendConfiguration} from "@common/configuration";
import {getDirectoryHint} from "@common/utils";
import {ImplicitFlow, JwtValidator, ThemeProvider} from "@vacasa/react-components-lib";
import DefaultTheme from "@vacasa/react-components-lib/src/themes/default";
import {App} from "./components/app/App";
import "./index.scss";

const params = new URLSearchParams(window.location.search);
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

let token: string = params.get("token");
const adminConfig = FrontendConfiguration.adminConfig();

Sentry.init({
  dsn: FrontendConfiguration.getSentryDsn(),
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 0.01,
});

const implicitFlowConfig = FrontendConfiguration.implicitFlowConfig(getDirectoryHint(token));

root.render(
  // @ts-ignore
  <React.StrictMode>
    <ThemeProvider theme={DefaultTheme}>
      <JwtValidator jwt={token} base64Key={adminConfig.publicKey} storageName={FrontendConfiguration.tokenStorageName}>
        <ImplicitFlow {...implicitFlowConfig}>
          <App />
        </ImplicitFlow>
      </JwtValidator>
    </ThemeProvider>
  </React.StrictMode>
);
